import { CacheRepository } from './iCacheRepository';
import { CacheKeys } from './cacheKeys';

const SECOND = 1000;
const HOUR = SECOND * 3600;
const DAY = HOUR * 24;
const YEAR = DAY * 365;

export class CookieCache implements CacheRepository {
    public get<T>(key: CacheKeys): T {
        const value: string = $.cookie(`cache_${key}`) as string | undefined;

        if (typeof value === 'undefined') {
            return value;
        }

        return JSON.parse(value) as T;
    }

    public set<T>(key: CacheKeys, value: T): boolean {
        $.cookie(`cache_${key}`, JSON.stringify(value), {
            secure: true,
            path: '/',
            expires: (Date.now()) + YEAR
        });

        return true;
    }

    public delete(key: CacheKeys): boolean {
        $.cookie(`cache_${key}`, '', {
            domain: `.${window.app.config.domain}`,
            path: '/'
        });
        return true;
    }
}
